/* LIBRAIRIES */
import React from 'react'

const ModalPicture = ({ url, onClose }) => {

    function handleClick(e) {
        e.stopPropagation();
        onClose();
    }

    return (
        <div className="container-modal-picture" onClick={(e) => handleClick(e)}>
            <div className='content-modal-picture'>
                <img src={url} alt='zoom document' style={{width: "100%", height: '100%'}} />
            </div>
        </div>
    )
}

export default ModalPicture;